import { useCallback, useEffect, useState } from "react";
import { ConnectionConfiguration } from "../connectionConfigurationPage/connectionConfiguration";
import { ConnectionPage } from "../connectionPage/connectionPage";
import FileFilterPage from "../fileFilterPage/FileFilterPage";
import "./integrationDashboard.css";
import { connectionProfileType, connectionType, fieldInfoMap, IntegrationEntity, mediaType, RemoteFileInfo, RemoteStreamLoadFile, SalesMapperFieldConfig, SummaryAttributesType } from "../../types/types";
import { useDispatch, useSelector } from "react-redux";
import { IntegrationActions } from "../../stateManagement/actions/integrationDashboardActions";
import { Box, Button } from "@mui/material";
import { Transformer } from "../transformer/Transformer";
import { getConnectionConfigurations, getEntityFieldMappingInfo, getFileMetaFromProfile, getIntegrationConfig, getIntegrationEntities } from "../../services/integrationService";
import { isUndefinedorEmpty } from "../transformer/UnregisteredFunctions";
import { GridColDef } from "@mui/x-data-grid";
import ReviewPage from "../reviewPage/ReviewPage";
import ScheduleListPage from "../scheduleListPage/ScheduleListPage";
import IntegrationToolStepper from "../integrationStepper/integrationStepper";
import ExportExceptionFilePage from "../exportExceptionConfig/ExportExceptionConfig";

const initialConnectionType:connectionType ={
    "providerType" : "",
    "image": "",
    "name": "",
    "attributes": [{}]
}

const defaultProfile: connectionProfileType = {
name: "",
type: "remote-stream",
payload: "",
lob: "",
attributes: {
        provider: "",
    },
};

export function IntegrationDashboard() {

    const [index,setState] = useState(-1);

    const authContext = JSON.parse(localStorage.authContext)

    const dispatch = useDispatch();
    const createIntegration = () => {
        dispatch(IntegrationActions.reset());
        dispatch(IntegrationActions.setLob(authContext.user.lob))
        setState(0)
    }
    const cancel = () => {
        dispatch(IntegrationActions.reset());
        dispatch(IntegrationActions.setLob(authContext.user.lob))
        setState(-1)
    }

    const initialProfileName : string = useSelector((state: any) => state.integrationRegistry.profileName); // profileName from redux store
    const entityName : string = useSelector((state:any)=> state.integrationRegistry.entityName); // entityName from redux store
    
    const [config ,setConfig] = useState<any>({}); // config >({});
    
    const stepperMapping:(string|null)[] = config.stepperMapping // config stepperMapping
    const EncodingOptions:string[] = config.encodingOptions; // config encodingOptions
    const DelimiterOptions:{[key:string]:string}[] = config.delimiterOptions; // config delimiterOptions
    const fileFilterColumnsConfig:GridColDef[] = config.fileFilterColumnsConfig; // config fileFilterColumnsConfig
    const mapperConfig:SalesMapperFieldConfig[] = config.salesHeaderFieldConfig; // config salesHeaderFieldConfig
    const summaryAttributesConfig:SummaryAttributesType[] = config.summaryAttributesConfig; // config summaryAttributesConfig
    const profileAttributes : connectionType[] = config.connectionType;     // config connectionType
    const mediaList : mediaType[] = config.mediaType;

    const fetchIntegrationToolConfig = useCallback(async () => {
      const response = await getIntegrationConfig();
      setConfig(response[0].domainValues[0]);
    }, []);

    const [connectionProfileList, setConnectionProfiles] = useState<connectionProfileType[]>([]);  // connectionProfileList > ([])

    const fetchConnectionProfiles = useCallback(async () => {
        const response: connectionProfileType[] = await getConnectionConfigurations();
        setConnectionProfiles(response);
    }, []);

    const [entitiesList, setEntitiesList] = useState<IntegrationEntity[]>([]); // entitiesList > ([])
    
    const fetchIntegrationEntitiesList = useCallback(async () => {
        const entitiesList = await getIntegrationEntities();
        setEntitiesList(entitiesList);
    }, []);

    useEffect(() => {
      fetchIntegrationToolConfig();
      fetchIntegrationEntitiesList();
      fetchConnectionProfiles();
    }, [fetchIntegrationToolConfig,fetchIntegrationEntitiesList,fetchConnectionProfiles])
      
    const [connection,setConnection]=useState(initialConnectionType); 
    
    const activeProfile : connectionProfileType = connectionProfileList.find((profile) => profile.name === initialProfileName) || defaultProfile;

    const [remoteFileInfo,setRemoteFileInfo] = useState<RemoteStreamLoadFile>({} as RemoteStreamLoadFile);

    const [fieldList, setFieldList] = useState<fieldInfoMap[]>([]);
    
    const fetchEntityMapping = useCallback(async () => {
        if(!isUndefinedorEmpty(entityName)){
            const response = await getEntityFieldMappingInfo(
                entityName,
                authContext.user.lob
            );
            const mappingList: fieldInfoMap[] = Object.values(response);
            setFieldList(mappingList);
        }
	}, [entityName,authContext.user.lob]);

    useEffect(() => {
        fetchEntityMapping();
    }, [fetchEntityMapping]);
    
    return (
    <Box className="white-box1">
        <h4 className="integration-dashboard-heading">Integration Platform</h4>
        <Button onClick={index === -1 ? createIntegration : cancel} variant="contained" color="info" className="navigation-btn top-bar-navigation-btn">{index === -1 ? "Create Integration" : "Cancel"}</Button>
        <Box className={"integration-dashboard-box integration-inputs"} position={"relative"}>
        {index === -1 && <ScheduleListPage increment={() => setState(index + 1)} />}
            { index >= 0 && <IntegrationToolStepper index={index} setState={setState} stepperMapping={stepperMapping} />}
            { index >= 0 && <div style={{display:index === 0 ? "block" : "none"}}>
                             <ConnectionPage profileAttributes={profileAttributes} setConnectionType={setConnection} activeProfile = {activeProfile} increment={()=> setState(index+1)} decrement={() => setState(index-1)} /></div> }
            { index === 1 && <ConnectionConfiguration profileList = {connectionProfileList} activeProfile = {activeProfile} connectionType={connection} decrement={()=>setState(index-1)} increment={()=>{fetchConnectionProfiles();setState(index+1);}}/> }
            { index >= 2 && <div style={{display:index === 2 ? "block" : "none"}}>
                <FileFilterPage activeProfile={activeProfile} DelimiterOptions={DelimiterOptions} EncodingOptions={EncodingOptions} entitiesList={entitiesList} updateRemoteFile={setRemoteFileInfo} fileFilterColumnsConfig={fileFilterColumnsConfig} decrement={() => setState(index - 1)} increment={() => setState(index + 1)}/></div>}
            { index === 3 && <Transformer fieldList={fieldList} mapperConfig={mapperConfig} remoteFileInfo={remoteFileInfo} decrement={()=>setState(index-1)} increment={()=>setState(index+1)}/> }
            { index >= 0 && <div style={{display:index === 4 ? "block" : "none"}}>
                <ExportExceptionFilePage mediaProfileConfigList={mediaList} integrationEntityList={entitiesList} decrement={()=>setState(index-1)} increment={()=>setState(index+1)}/></div> }
            { index === 5 && <ReviewPage entitiesList={entitiesList} summaryAttributesConfig={summaryAttributesConfig} decrement={()=>setState(index-1)} increment={()=>setState(index+1)} cancel={cancel}/> }
        </Box>
    </Box>
    );
}


